import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Re-export security utilities for convenience
export { maskIP, maskUserId, maskEmail, useRevealSensitiveData } from './security-utils';

// Re-export username utilities for convenience
export { 
  validateUsernameFormat, 
  generateUsernameSuggestions, 
  normalizeUsername,
  RESERVED_USERNAMES,
  INAPPROPRIATE_WORDS
} from './name-utils';
